import {
  ODataHeader,
  ODataString,
  ODataEnum,
  ODataBoolean,
  ODataInteger,
} from "pbas-vue-components";
import { translate2 } from "../trans2";
import { i18n } from "@/plugins/i18n";
import Vue, { VueConstructor } from 'vue';
import { VBtn } from 'vuetify/lib';

function getProvidersHeaders(coverage) {
  const headers = [
    new ODataHeader({
      title: "Id",
      type: new ODataString("Id"),
      sortable: true,
      visible: false,
      searchable: false,
      isIdentifier: true,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      title: "components.claims.provider_dialog.unique_id",
      type: new ODataString("UniqueId"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
      version:1
    }),
    new ODataHeader({
      title: "headers.members_management.First Name",
      type: new ODataString("FirstName"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new ODataHeader({
      title: "headers.members_management.Last Name",
      type: new ODataString("LastName"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    // new ODataHeader({
    //   title: "headers.members_management.Email",
    //   type: new ODataString("ProviderOffices[]/Email"),
    //   sortable: true,
    //   visible: false,
    //   searchable: false,
    //   allowVisibilityChange: false,
    //   version: 2
    // }),
    new ODataHeader({
      title: "globals.coverage",
      type: new ODataEnum("ProviderType", {
        getString: (item) => {
          return i18n.t("enums." + item.ProviderType);
        },
        dropdownItems: coverage,
      }),
      sortable: true,
      visible: true,
      searchable: true,
      version: 1
    }),
    new ODataHeader({
      title: "headers.providers_index.office_numbers",
      type: new ODataString("ProviderOffices[]/Office/OfficeNumber", {
        // getString: (item) =>
        //   item.ProviderOffices.map((o) => o.Office.OfficeNumber).join(", "),
        getHtml: (item) => {
          return item.ProviderOffices.map((o) => {
            return `<a id="${o.ProviderId}:${o.OfficeId}">${
              o.Office.OfficeNumber
            }</a>`;
          }).join(", ");
        },
        // getComponent: (
        //   item
        // ) => {
        //   const data = {
        //     data: item,
        //   };
        //   const v = Vue.extend({
        //     template:
        //       `<v-btn @click='openOffice'></v-btn>`,
        //     components: {
        //       VBtn,
        //     },
        //     data: () => data,
        //   });
        //   return v;
        // },
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      type: new ODataString("ProviderOffices[]/Office/Id"),
      sortable: true,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("ProviderOffices[]/Office/Address1"),
      sortable: true,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("ProviderOffices[]/Office/Address2"),
      sortable: true,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("ProviderOffices[]/Office/Address3"),
      sortable: true,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("ProviderOffices[]/Office/City"),
      sortable: true,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("ProviderOffices[]/Office/Province/Id"),
      sortable: true,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("ProviderOffices[]/Office/Province/Name"),
      sortable: true,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("ProviderOffices[]/Office/Province/Translations[]/DisplayValue"),
      sortable: true,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("ProviderOffices[]/Office/Province/Translations[]/LanguageCode"),
      sortable: true,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("ProviderOffices[]/Office/Province/Code"),
      sortable: true,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("ProviderOffices[]/Office/PostalCode"),
      sortable: true,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("ProviderType"),
      sortable: true,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("ImportType"),
      sortable: true,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("MiddleName"),
      sortable: true,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("LanguageChoiceId"),
      sortable: true,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("LanguageChoice/Name"),
      sortable: true,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("LanguageChoice/Id"),
      sortable: true,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("LanguageChoice/Translations[]/LanguageCode"),
      sortable: true,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("LanguageChoice/Translations[]/DisplayValue"),
      sortable: true,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
  ];
  return headers;
}
export default getProvidersHeaders;
